<script lang="ts">
  export let urlForQrCode: string;

  import qrcode from "qrcode-generator";

  let qr = qrcode(0, 'L');
  qr.addData(urlForQrCode);
  qr.make();

  let qrImg = qr.createImgTag(4);

</script>

<span>
  {@html qrImg}
</span>
